/**
 * MeasureTypesEditor Component
 *
 * Entity-specific editor for MeasureTypes lookup table
 * Include cost_or_benefit dropdown (Cost/Benefit)
 */

import {
  useMeasureTypes,
  useCreateMeasureType,
  useUpdateMeasureType,
  useDeleteMeasureType,
} from '@medsuite/api-client';

import EntityEditor from '../components/EntityEditor';

interface MeasureTypesEditorProps {
  onDataLoaded?: (count: number) => void;
}
export default function MeasureTypesEditor({ onDataLoaded }: MeasureTypesEditorProps) {
  const { data: measureTypes = [], isLoading, error } = useMeasureTypes();
  const addMutation = useCreateMeasureType();
  const updateMutation = useUpdateMeasureType();
  const deleteMutation = useDeleteMeasureType();

  const columns = [
    { key: 'measure_type_id', label: 'ID', readonly: true },
    { key: 'measure_type_name', label: 'Measure Type Name', type: 'text' as const },
    {
      key: 'cost_or_benefit',
      label: 'Cost or Benefit',
      type: 'select' as const,
      options: [
        { value: 'C', label: 'Cost' },
        { value: 'B', label: 'Benefit' },
      ],
    },
  ];

  return (
    <EntityEditor
      title="Measure Types"
      columns={columns}
      data={measureTypes as unknown as Record<string, unknown>[]}
      isLoading={isLoading}
      error={error}
      primaryKey="measure_type_id"
      onDataLoaded={onDataLoaded}
      onAdd={async (item) => {
        await addMutation.mutateAsync(
          item as { measure_type_name: string; cost_or_benefit: 'C' | 'B' }
        );
      }}
      onUpdate={async (id, item) => {
        await updateMutation.mutateAsync({
          id: Number(id),
          data: item as Partial<{ measure_type_name: string; cost_or_benefit: 'C' | 'B' }>,
        });
      }}
      onDelete={(id) => deleteMutation.mutateAsync(Number(id))}
      isAdding={addMutation.isPending}
      isUpdating={updateMutation.isPending}
      isDeleting={deleteMutation.isPending}
    />
  );
}
